import PropTypes from 'prop-types';
import Default from './default';
import GiftVoucher from './gift_voucher';

const ExperienceBody = ({ experience }) => {
  const { product_name_underscore } = experience;

  // determine which experience body to render
  switch (true) {
    case product_name_underscore?.endsWith('gift_vouchers'):
      return <GiftVoucher experience={experience} />;

    default:
      return <Default experience={experience} />;
  }
};

ExperienceBody.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  experience: PropTypes.object.isRequired,
};

export default ExperienceBody;
